import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginPageComponent} from './shared/components/auth/login-page/login-page.component';
import {NotFoundPageComponent} from './shared/components/error/not-found-page/not-found-page.component';

import {keycloakGuard} from "./core/guards/keycloak.guard";
import {LoginSuccessComponent} from "./shared/components/login-success/login-success.component";
import { CheckStatusComponent } from './shared/components/check-status/check-status.component';
import { animation } from '@angular/animations';


const routes: Routes = [
  {path: 'login', component: LoginPageComponent},
  {
    path: 'dashboard',
    loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
    data: {preload: true, animation: 'dashboardPage'},
    canActivate: [keycloakGuard]
  },
  {
    path: 'controlli',
    loadChildren: () => import('./modules/controlli/controlli.module').then(m => m.ControlliModule),
    data: {preload: true, animation: 'controlliPage'},
    canActivate: [keycloakGuard]
  },
  {
    path: 'punti-campionamento',
    loadChildren: () => import('./modules/punti-campionamento/punti-campionamento.module').then(m => m.PuntiCampionamentoModule),
    data: { preload: true, animation: 'punti-campionamentoPage' },
    canActivate: [keycloakGuard]
  },
  {
    path: 'trasmissione-reportnet',
    loadChildren: () => import('./modules//trasmissione-reportnet/trasmissione-reportnet.module').then(m => m.TrasmissioneReportNetModule),
    data: { preload: true, animation: 'punti-campionamentoPage' },
    canActivate: [keycloakGuard]
  },
  {
    path: 'punti-campionamento-tipologie',
    loadChildren: () => import('./modules/punti-campionamento-tipologie/punti-campionamento-tipologie.module').then(m => m.PuntiCampionamentoTipologieModule),
    data: { preload: true, animation: 'punti-campionamento-tipologiePage' },
    canActivate: [keycloakGuard]
  },
  {
    path: 'acquedotti',
    loadChildren: () => import('./modules/acquedotti/acquedotti.module').then(m => m.AcquedottiModule),
    data: { preload: true, animation: 'acquedottiPage' },
    canActivate: [keycloakGuard]
  },
  {
    path: 'arera-ato',
    loadChildren: () => import('./modules/arera-ato/arera-ato.module').then(m => m.AreraAtoModule),
    data: { preload: true, animation: 'arera-atoPage' },
    canActivate: [keycloakGuard]
  },
  {
    path: 'arera-gestore',
    loadChildren: () => import('./modules/arera-gestore/arera-gestore.module').then(m => m.AreraGestoreModule),
    data: { preload: true, animation: 'arera-gestorePage' },
    canActivate: [keycloakGuard]
  },
  {
    path: 'parametri',
    loadChildren: () => import('./modules/parametri/parametri.module').then(m => m.ParametriModule),
    data: { preload: true, animation: 'parametriPage' },
    canActivate: [keycloakGuard]
  },
  {
    path: 'water-supply-zone',
    loadChildren: () => import('./modules/water-supply-zone/water-supply-zone.module').then(m => m.WaterSupplyZoneModule),
    data: { preload: true, animation: 'water-supply-zonePage' },
    canActivate: [keycloakGuard]
  },
  {
    path: 'istat-regioni',
    loadChildren: () => import('./modules/istat-regioni/istat-regioni.module').then(m => m.IstatRegioniModule),
    data: { preload: true, animation: 'istat-regioniPage' },
    canActivate: [keycloakGuard]
  },
  {
    path: 'istat-comuni',
    loadChildren: () => import('./modules/istat-comuni/istat-comuni.module').then(m => m.IstatComuniModule),
    data: { preload: true, animation: 'istat-comuniPage' },
    canActivate: [keycloakGuard]
  },
  {
    path: 'settings',
    loadChildren: () => import('./modules/settings/settings.module').then(m => m.SettingsModule),
    data: {preload: true, animation: 'settingsPage'},
    canActivate: [keycloakGuard]
    // canMatch: [authGuard]
  },
  {
    path: 'elaborazioni',
    loadChildren: () => import('./modules/elaborazioni/elaborazioni.module').then(m => m.ElaborazioniModule),
    data: { preload: true, animation: 'amministrazionePage' },
    canActivate: [keycloakGuard]
  },
  {
    path: 'credenziali-api',
    loadChildren: () => import('./modules/credenziali-api/credenziali-api.module').then(m => m.CredenzialiApiModule),
    data: {preload: true, animation: 'amministrazionePage'},
    canActivate: [keycloakGuard]
    // canMatch: [authGuard]
  },
  {
    path: 'admin',
    loadChildren: () => import('./modules/amministrazione/amministrazione.module').then(m => m.AmministrazioneModule),
    data: {preload: true, animation: 'amministrazionePage'},
    canActivate: [keycloakGuard]
    // canMatch: [authGuard]
  },
  {
    path: 'tenant',
    loadChildren: () => import('./modules/tenant/tenant.module').then(m => m.TenantModule),
    data: {preload: true, animation: 'tenantPage'},
    canActivate: [keycloakGuard]
    // canMatch: [authGuard]
  },
  {path: 'login_success', component: LoginSuccessComponent},
  {path: 'check-status', component: CheckStatusComponent,pathMatch: 'full'},
  {path: '', redirectTo: '/dashboard', pathMatch: 'full'},
  {path: '**', component: NotFoundPageComponent, data: {animation: 'notFoundPage'},},

  // { path: 'dashboard', component: DashboardComponent, canActivate: [authGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { bindToComponentInputs: true })],//, { enableTracing: true } ***for routing debug***
  exports: [RouterModule]
})
export class AppRoutingModule {
}
